// @ts-nocheck
import { forwardRef, useCallback } from "react";
import { toast } from "react-hot-toast";
import IntlMessages from "../../../../@richbeauty/utility/IntlMessages";
import AppFormModal from "../../../../@richbeauty/core/AppFormModal";
import { revalidateCustomerLeads } from "../../../../@richbeauty/utility/helper/cacheRevalidator";
import useCreateOrEditCustomerLeadFieldConfig from "./useCreateOrEditCustomerLeadFieldConfig";
import { CUSTOMER_LEAD_STATUS } from "shared/constants/AppConst";
import useCreateCustomerLead from "hooks/apis/customerLeads/useCreateCustomerLead";

const CreateCustomerLeadModal = forwardRef((_, ref) => {
  const {
    trigger: triggerCreateCustomerLead,
    isMutating: isMutatingCreateCustomerLead,
  } = useCreateCustomerLead();
  const createOrEditCustomerLeadFieldConfig =
    useCreateOrEditCustomerLeadFieldConfig({
      isCreate: true,
    });

  const onHandleCreateCoupon = useCallback(
    (formData) => {
      let formDataClone = { ...formData };
      if (!formDataClone?.status) {
        formDataClone = {
          ...formDataClone,
          status: CUSTOMER_LEAD_STATUS[0].value,
        };
      }
      if (formDataClone?.email?.trim() === "") {
        delete formDataClone.email;
      }
      triggerCreateCustomerLead(formDataClone, {
        onSuccess: () => {
          revalidateCustomerLeads();
          ref.current?.closeModal();
        },
        onError: (error) => toast.error(error?.message),
      });
    },
    [triggerCreateCustomerLead, ref]
  );

  return (
    <AppFormModal
      ref={ref}
      title={<IntlMessages id="app.customerLeads.createCustomerLead" />}
      onFinish={onHandleCreateCoupon}
      isSubmitting={isMutatingCreateCustomerLead}
      fieldsConfig={createOrEditCustomerLeadFieldConfig}
    />
  );
});

export default CreateCustomerLeadModal;
